












































import { Component, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

interface AuditCard {
  name: string;
  title: string;
  subtitle: string;
  desc: string;
  icon: string;
  color: string;
  code: string;
}

@Component
export default class AuditMenuPage extends Vue {
  readonly audits: AuditCard[] = [
    {
      name: "ppi-injection-audit",
      title: "Audit Penyuntikan Aman",
      subtitle: "Audit Penyuntikan Yang Aman",
      desc: "Checklist 21 item penyuntikan aman + SKP 3 + log NSI, 4-tier sign.",
      icon: "mdi-needle",
      color: "red",
      code: "audit_penyuntikan_aman"
    },
    {
      name: "ppi-audit-etika-batuk",
      title: "Audit Etika Batuk",
      subtitle: "RSPS/AUDIT-EB/001",
      desc: "Audit Etika Batuk / Respiratory Hygiene (WHO IPC), 4 kriteria per sesi.",
      icon: "mdi-lungs",
      color: "orange",
      code: "audit_etika_batuk"
    },
    {
      name: "ppi-audit-limbah",
      title: "Audit Kepatuhan Membuang Limbah",
      subtitle: "RSPS/AUDIT-LIMBAH/001",
      desc: "4 item (kantong hitam/kuning, limbah cair, benda tajam) + skoring, 4-tier sign.",
      icon: "mdi-delete-alert-outline",
      color: "brown",
      code: "audit_limbah"
    },
    {
      name: "ppi-audit-kepatuhan",
      title: "Audit Kepatuhan PPI RS",
      subtitle: "RSPS/AUDIT-PPI/001",
      desc: "Multi-seksi A–F: APD / IV / kateter / linen / instrument / alat reuse.",
      icon: "mdi-clipboard-list-outline",
      color: "indigo",
      code: "audit_kepatuhan_ppi"
    },
    {
      name: "ppi-audit-kebersihan-ruang",
      title: "Audit Kebersihan Ruang Rawat",
      subtitle: "RSPS/AUDIT-KRR/001",
      desc: "14 item kebersihan bedside/ruang rawat + skoring, 2-tier sign.",
      icon: "mdi-bed-outline",
      color: "teal",
      code: "audit_kebersihan_ruang"
    },
    {
      name: "ppi-audit-kebersihan-alat",
      title: "Audit Kebersihan Alat Kesehatan",
      subtitle: "RSPS/AUDIT-KAK/001",
      desc: "13 item kebersihan alat kesehatan/keperawatan bedside, 2-tier sign.",
      icon: "mdi-wheelchair-accessibility",
      color: "cyan",
      code: "audit_kebersihan_alat"
    },
    {
      name: "kesling-audit",
      title: "Audit Kebersihan Lingkungan",
      subtitle: "RSPS/AUDIT-KL/001",
      desc: "17 item checklist kebersihan lingkungan (SNARS PPI.7), 2-tier sign.",
      icon: "mdi-sprout-outline",
      color: "green",
      code: "audit_lingkungan"
    },
    {
      name: "ppi-hh-fasilitas-audit",
      title: "Audit Fasilitas Hand Hygiene",
      subtitle: "RM.PPI.HH.02 — Fasilitas",
      desc: "Checklist ketersediaan sarana HH per ruangan (8 item) + skoring.",
      icon: "mdi-water-pump",
      color: "blue",
      code: "audit_hh"
    },
    {
      name: "ppi-hh-audit",
      title: "Audit Kepatuhan Hand Hygiene",
      subtitle: "RM.PPI.HH.02 — Kepatuhan",
      desc: "Saat HH (5 momen WHO) + prosedur Hand Wash &amp; Hand Rub, 3-tier sign.",
      icon: "mdi-hand-wash",
      color: "light-blue",
      code: "audit_hh"
    },
    {
      name: "ppi-audit-fasilitas-apd",
      title: "Audit Fasilitas APD",
      subtitle: "RSPS/AUDIT-APD-FAS/001",
      desc: "Checklist ketersediaan sarana/fasilitas APD per ruangan (6 item), 4-tier sign.",
      icon: "mdi-shield-account",
      color: "deep-purple",
      code: "audit_apd"
    }
  ];

  get visibleAudits(): AuditCard[] {
    return this.audits.filter(a => userModule.hasPrivilege(a.code, "view"));
  }

  goto(name: string) {
    if (this.$route.name !== name) {
      this.$router.push({ name });
    }
  }
}
